import React from 'react';
import styled from 'styled-components';
import { Icon } from '../../helper/icons';
import { Palette } from '../utils';

const IconTile = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 4px;
  background: ${Palette.SOLITUDE};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
`;

const IconMask = styled.div`
  width: 28px;
  height: 28px;
  background-color: ${Palette.HAZY_BLUE};
  mask-image: url(${(p) => p.$src});
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;
  -webkit-mask-image: url(${(p) => p.$src});
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  -webkit-mask-size: contain;
`;

const IconFallback = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;

  svg {
    width: 28px;
    height: 28px;
  }

  svg,
  svg path {
    fill: ${Palette.HAZY_BLUE};
  }
`;

export function IconWithBg({ iconSrc, fallbackIcon, className }) {
  const content = iconSrc ? (
    <IconMask $src={iconSrc} role="img" aria-hidden />
  ) : fallbackIcon ? (
    <IconFallback>
      <Icon icon={fallbackIcon} />
    </IconFallback>
  ) : null;

  if (!content) {
    return null;
  }

  return <IconTile className={className}>{content}</IconTile>;
}
